import { Component } from '@angular/core';
import { BaseComponent } from "../../views/base.component";
import { Invoice } from "../../models/billing.model";
import { ChartParams } from "../../views/chart/chart.component";
import { EventsService } from "../../lib/EventsService";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "../../translate";
import { ModalService } from "../../views/modal/base_modal.component";
import { FilterFormService } from "../../views/filter_form/filter_form.service";
import { HttpClient } from "@angular/common/http";
import { HelperService } from "../../lib/helper.service";
import { Site } from "../../models/support.model";
import { BillingService2 } from "../billing.service";

interface PromopultTotalStat {
	userCount: number;
	siteCount: number;
	firstManualPaidCount: number;
	secondManualPaidCount: number;
	moneyCount: number;
	commissionMoneyCount: number;
	expense: number;
	commission: number;
}

interface PromopultStat {
	timestamp: number;
	userCount: number;
	firstManualPaidCount: number;
	secondManualPaidCount: number;
	moneyCount: number;
	commissionMoneyCount: number;
	expense: number;
	commission: number;
}

interface Paid {
	transaction_date: string;
}

interface SiteStat {
	site: Site;
	invoice: Invoice;
	moneyCount: number;
	commissionMoneyCount: number;
	paid: Paid;
}

@Component({
  selector: 'app-promopult',
  templateUrl: './promopult.component.html',
  styles: []
})
export class PromopultComponent  extends BaseComponent {
	promopultTotalStats: PromopultTotalStat[];
	promopultStats: PromopultStat[];
	siteStats: SiteStat[];
	
	regAndPaidChart = new ChartParams();
	firstAndManualChart = new ChartParams();
	siteChart = new ChartParams({
		title: 'Сайты',
		type: 'bar',
		axis: {
			x: {
				show: true,
				label: {
					text     : 'Дата создания сайта',
					position : 'outer-middle'
				}
			},
			y: {
				show: true,
				label: {
					text     : 'Сайты',
					position : 'outer-middle'
				}
			}
		},
	});
	
	statsLoader: boolean = false;
	statsLoader2: boolean = false;
	totalStatLoader: boolean = false;
	
	addFilterParams = {
		period: 'month',
	};

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public modalService: ModalService,
		public filter: FilterFormService,
		public http: HttpClient,
		public helper: HelperService,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
		
		const me = this;
		
		me.regAndPaidChart.setOptions({
			title: me.translate.__A('promopult.regAndPaid'),
			names: {
				'countReg': this.translate.__A('users.reg_day.countReg'),
				'paidCount': this.translate.__A('common.paidCount'),
			},
		});

		me.firstAndManualChart.setOptions({
			title: me.translate.__A('promopult.firstAndManual'),
			names: {
				'firstPaidCount': this.translate.__A('billing.billing.firstPaidCount'),
				'repeatPaidCount': this.translate.__A('billing.billing.repeatPaidCount'),
			},
		});
		
		me.siteChart.setOptions({
			names: {
				'siteCount': this.translate.__A('users.reg_day.created sites'),
			},
		})
	}
	
	
	async getData() {
		await this.getCharts();
		await this.getStats();
		await this.getTotalStats();
		await this.getSitesStats();
	}
	
	
	async getStats() {
		const me = this;
		
		me.statsLoader = true;
		const {
			stats,
		} = await me.service2.promopultBilling.stats(
			{ ...me.filter.getFilterParams(), period: 'month', }
		).toPromise();
		
		me.promopultStats = stats;

		me.statsLoader = false;
	}

	async getTotalStats() {
		const me = this;

		me.totalStatLoader = true;

		const {
			stats,
		} = await me.service2.promopultBilling.stats(
			{ ...me.filter.getFilterParams() },
			'total_stats',
		).toPromise();

		me.promopultTotalStats = stats;

		me.totalStatLoader = false;
	}

	async getSitesStats() {
		const me = this;

		me.statsLoader2 = true;
		const {
			stats,
			pagination,
		} = await me.service2.promopultBilling.stats(
			{ ...me.filter.getFilterParams(), period: 'month', },
			'sites_stats'
		).toPromise();

		if (pagination) {
			me.pagination.fill(pagination);
			
			me.updateLinks(
				me.service2.promopultBilling.getRealFullRoute()
			);
		}
		
		me.siteStats = stats;

		me.statsLoader2 = false;
	}
	
	async getCharts() {
		const me = this;
		
		// chart 1
		me.regAndPaidChart.showLoader();
		
		const { charts: regAndPaidData } = await me.service2.promopultBilling.chart(
			me.filter.getFilterParams(),
			'regAndPaidChart'
		).toPromise();
		me.regAndPaidChart.data = regAndPaidData;
		
		me.regAndPaidChart.hideLoader();

		// chart 2
		me.firstAndManualChart.showLoader();

		const { charts: firstAndManualData } = await me.service2.promopultBilling.chart(
			me.filter.getFilterParams(),
			'firstAndManualChart'
		).toPromise();
		me.firstAndManualChart.data = firstAndManualData;

		me.firstAndManualChart.hideLoader();
		
		
		// chart 3
		me.siteChart.showLoader();

		const { charts: siteChartData } = await me.service2.promopultBilling.chart(
			me.filter.getFilterParams(),
			'site/chart'
		).toPromise();
		me.siteChart.data = siteChartData;

		me.siteChart.hideLoader();
	}

	async onPageChange(page: number = 1) {
		this.filter.filterParams.page = this.pagination.page;

		await this.getSitesStats();
	}
}
